import React, { useState, useEffect, useRef } from "react";
import "./ActualitesContainer.scss";
import Actualite from "../Actualite/Actualite";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { FaChevronRight } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDateDatabase, formatDateFrenchLocale } from "Services/functions";
import { updateNews } from "Redux/Actions/newsActions";
import { useFetchGet, useFetchGetPagination } from "Services/api";
import { registerLocale } from "react-datepicker";
import { fr } from "date-fns/locale";
import TempPagination from "Components/Pagination/TempPagination";
import Loader from "Components/Loader/loader";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import Filters from "Components/Filters/Filters";
registerLocale("fr", fr);
/**
 * Permet d'afficher les actualités et actus/conseils
 */
const ActualitesContainer = (props) => {
  const [loginVisible, setLoginVisible] = useState(false);
  // Fetch les catégories des actus depuis la BDD
  const categoriesData = useFetchGet(
    props.pageActus === "accueil" ? null : "/news_categories",
    props.auth.token
  );
  const actualitesContainerRef = useRef(null);
  //
  const [categories, setCategories] = useState([]);

  // Les différents filtres de recherche des actualités
  const [filtreDate, setFiltreDate] = useState(null);
  const [filtreMotsCles, setFiltreMotsCles] = useState("");
  const [filtreCategory, setFiltreCategory] = useState(null);
  const [isKeywordFiltering, setIsKeywordFiltering] = useState(false);
  const [newsUrl, setNewsUrl] = useState(props.queryUrl ?? null);

  const newsQuery = useFetchGetPagination(
    newsUrl,
    props.auth.token,
    props.handleUpdateNews
  );

  useEffect(() => {
    if (props.queryUrl && props.queryUrl !== newsUrl) {
      setNewsUrl(props.queryUrl);
    }
  }, [props.queryUrl]);

  useEffect(() => {
    return () => {
      props.handleUpdateNews({ dataFromPagination: null });
    };
  }, []);

  useEffect(() => {
    /// Récupérer les catégories, et les filtrer par ordre alphabétique
    if (categoriesData?.loaded && categoriesData.data.length > 0) {
      setCategories([]);
      let tempArray = [];
      categoriesData.data.forEach((category) => tempArray.push(category));
      tempArray = tempArray.sort((a, b) => a.label.localeCompare(b.label));
      setCategories(tempArray);
    }
  }, [categoriesData?.loaded]);

  // Fonction globale de filtre
  const handleFilter = () => {
    if (props.states.statesData.length > 0) {
      let url = new URL(`${process.env.REACT_APP_BASE_URL_API}/news`);
      url.searchParams.set(
        "state",
        props.states.statesData.filter(
          (etat) => etat.statusLabel === "Publié"
        )[0].id
      );
      url.searchParams.set("order[modifiedAt]", "desc");
      if (filtreMotsCles != "") url.searchParams.set("keyword", filtreMotsCles);
      if (filtreCategory) url.searchParams.set("category", filtreCategory.id);
      if (filtreDate && filtreDate[0])
        url.searchParams.set(
          "modifiedAt[after]",
          formatDateDatabase(filtreDate[0])
        );
      if (filtreDate && filtreDate[1])
        url.searchParams.set(
          "modifiedAt[before]",
          formatDateDatabase(filtreDate[1])
        );
      props.nbActus && url.searchParams.set("itemsPerPage", props.nbActus);
      setNewsUrl(url);
    }
  };

  useEffect(() => {
    if (
      (!filtreDate || (filtreDate[0] && filtreDate[1])) &&
      (!props.queryUrl || props.nbActus === 12)
    ) {
      handleFilter();
    }
  }, [
    filtreCategory,
    filtreDate,
    isKeywordFiltering,
    props.states.statesData.length,
  ]);
  return (
    <div className="actualites_container">
      <div className="actualites_container__top">
        {props.pageActus == "accueil" ? (
          // si on est dans la page d'accueil on n'affiche pas les filtres
          <div className="actualites_container__top__title">
            <h1 className="h1_trait_dessus">
              {props.title ? props.title : "Les actus"}
            </h1>
          </div>
        ) : (
          <div className="actualites_container__top__title">
            {/* si on est sur la page Actualites on affiche les filtres */}
            <h1 className="h1_trait_dessus">
              {props.title ? props.title : "Toutes les actus"}
            </h1>
            <div className="actualites_container__top__title__filtres__visible">
              <Filters
                filtreMotsCles={filtreMotsCles}
                setFiltreMotsCles={setFiltreMotsCles}
                filtreDate={filtreDate}
                setFiltreDate={setFiltreDate}
                filtreDropdown={filtreCategory}
                setFiltreDropdown={setFiltreCategory}
                dataDropdown={categories}
                setIsKeywordFiltering={setIsKeywordFiltering}
                filterFunction={handleFilter}
              ></Filters>
            </div>
            <Accordion
              className="accordion_actus"
              expandIcon="pi pi-sliders-h"
              collapseIcon="pi pi-sliders-h"
            >
              <AccordionTab header="Filtres de recherche">
                <Filters
                  filtreMotsCles={filtreMotsCles}
                  setFiltreMotsCles={setFiltreMotsCles}
                  filtreDate={filtreDate}
                  setFiltreDate={setFiltreDate}
                  filtreDropdown={filtreCategory}
                  setFiltreDropdown={setFiltreCategory}
                  dataDropdown={categories}
                  setIsKeywordFiltering={setIsKeywordFiltering}
                  filterFunction={handleFilter}
                ></Filters>
              </AccordionTab>
            </Accordion>
          </div>
        )}
        {/* peu importe la page on affiche le container avec les actualités */}

        <div
          className="actualites_container__body"
          ref={actualitesContainerRef}
        >
          {newsQuery?.data ? (
            newsQuery.data.length > 0 ? (
              (props.nbActus && props.nbActus != 12
                ? newsQuery.data.slice(0, props.nbActus)
                : newsQuery.data
              ).map((actualite, index) =>
                props.auth.userConnected || actualite.public ? (
                  <Link
                    to={{
                      pathname: `/actu-detail/${actualite.id}`,
                      params: actualite.id,
                    }}
                    key={index}
                  >
                    <Actualite
                      key={actualite.id}
                      title={actualite.title}
                      chapeau={actualite.chapo}
                      url={
                        actualite?.imageUrl ||
                        actualite?.nexusImageUrl ||
                        "img1"
                      }
                      nexusUrl={actualite?.nexusImageUrl}
                      publicationDate={formatDateFrenchLocale(
                        actualite.publishedAt.date || actualite.publishedAt
                      )}
                      categorie={
                        actualite.newsCategoryLabel || actualite.category?.label
                      }
                      newsDetails={actualite}
                    />
                  </Link>
                ) : (
                  <Actualite
                    key={actualite.id}
                    title={actualite.title}
                    chapeau={actualite.chapo}
                    url={
                      actualite?.imageUrl || actualite?.nexusImageUrl || "img1"
                    }
                    nexusUrl={actualite?.nexusImageUrl}
                    publicationDate={formatDateFrenchLocale(
                      actualite.publishedAt.date || actualite.publishedAt
                    )}
                    categorie={
                      actualite.newsCategoryLabel || actualite.category?.label
                    }
                    newsDetails={actualite}
                    onClick={() => {
                      setLoginVisible(true);
                    }}
                  />
                )
              )
            ) : (
              <span>Aucune actualité ne correspond à votre recherche</span>
            )
          ) : (
            <Loader></Loader>
          )}
        </div>
        {loginVisible && (
          <ModalConnexion
            setVisibleModal={setLoginVisible}
            visibleModal={loginVisible}
          />
        )}
      </div>
      <div className="actualites_container__pagination">
        {props.pageActus == "accueil" ? (
          <BtnBleu
            btnTexte="Voir toutes les actus"
            btnAction={() => (window.location.href = "./actualites")}
          >
            <FaChevronRight />
          </BtnBleu>
        ) : (
          <TempPagination
            result={newsQuery}
            refItemParent={actualitesContainerRef}
            rows={50}
          />
        )}
      </div>
    </div>
  );
};

ActualitesContainer.propTypes = {
  auth: PropTypes.object,
  nbActus: PropTypes.number,
  pageActus: PropTypes.string,
  title: PropTypes.string,
  news: PropTypes.any,
  handleUpdateNews: PropTypes.func,
  states: PropTypes.object,
  queryUrl: PropTypes.string,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  news: state.news,
  pagination: state.pagination,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateNews: (value) => dispatch(updateNews(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActualitesContainer);
